module.exports = __webpack_public_path__ + "static/media/Lato-BlackItalic.5fc797bf.svg";